import { AutogenLayoutPartnerProfileNotes } from "./autogen/AutogenLayoutPartnerProfileNotes";

export class PartnerProfileNotes extends AutogenLayoutPartnerProfileNotes {
    private _notes;
    
    override onLoad() {
        this.labelNotes.text = this.notes;
    }
    
    public get notes() : string {
        return this._notes;
    }
    
    public set notes(value: string) {
        this._notes = value;
    }
} 